import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "description-box"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "title mb-3" }, "Description", -1)
const _hoisted_3 = ["innerHTML"]

import {
  Ref, computed, ref,
} from 'vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { descriptionWithLink } from '@/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const driveStore = useDriveStore();
const showAllDescription: Ref<boolean> = ref(false);

const description = computed(() => {
  if (showAllDescription.value) {
    return driveStore.currentCase.description;
  }
  return driveStore.currentCase?.description?.length >= 337 ? driveStore.currentCase.description.slice(0, 337) : driveStore.currentCase.description;
});


return (_ctx: any,_cache: any) => {
  return (_unref(driveStore).currentCase.description)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", {
          innerHTML: _unref(descriptionWithLink)(_unref(description))
        }, null, 8, _hoisted_3),
        (_unref(driveStore).currentCase?.description?.length > 337)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllDescription.value = !showAllDescription.value))
            }, _toDisplayString(showAllDescription.value ? 'Hide' : 'Show') + " full description", 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})